import { pinia } from '@/main'
import { watch } from 'vue'

export const usePiniaStateFromLocalStorage = () => {
  const storedState = JSON.parse(localStorage.getItem('piniaState') ?? '{}')

  const setStateInStorage = (state: typeof pinia.state) => {
    localStorage.setItem('piniaState', JSON.stringify(state))
  }

  // Persist pinia store to localStorage whenever it changes
  watch(pinia.state, setStateInStorage, { deep: true })

  return storedState
}
